import { config } from '@services/config';
import { OfferingWritingCompanySearchResponse } from '@lio/api-types';
import { productOfferingQueryKey } from '@services/writingCompany/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useWritingCompany = (isAdminOrUnderwriter: boolean, offeringId?: string) => {
  const client = useClient();
  const result = useQuery<OfferingWritingCompanySearchResponse, Error>({
    queryKey: productOfferingQueryKey.getWritingCompany(offeringId),
    ...config,
    queryFn: () => client.get(`offering/${offeringId}/writing-company`).json<OfferingWritingCompanySearchResponse>(),
    enabled: isAdminOrUnderwriter && !!offeringId && offeringId !== '',
  });
  return {
    ...result,
    writingCompanies: result.data,
  };
};
